import type { LedgerEntryIdPrefix } from '../enums/ledgerEntryIdPrefix'
import type { CreditorBalanceStatementEntry } from '../query-api'
import type { LedgerEntry } from '../types/LedgerEntry'
import { minorToMajor } from './moneyUtils'

export const normalizeLedgerEntry = (
  entry: CreditorBalanceStatementEntry,
  index: number,
  idPrefix: LedgerEntryIdPrefix,
): LedgerEntry => {
  return {
    id: `${idPrefix}-${entry.originatorType}-${entry.originatorRef}-${index}`,
    date: entry.entryDate,
    journal: entry.journal ?? '',
    description: entry.description ?? '',
    documentNumber: entry.bill?.documentNumber ?? '',
    transactionId: entry.transactionId ?? undefined,
    debit: minorToMajor(entry.debit.value),
    credit: minorToMajor(entry.credit.value),
    balance: minorToMajor(entry.runningBalance.value),
    isOpeningBalance: entry.isOpeningBalance,
  }
}
